/**
 * Description  管理配置 日志管理 黑马校验日志
 * rebuild:zhang.qiang 2017-4-12
 */
"use strict";
angular.module('logManageMentHeiMaLogModule', [
        'logManageMentHeiMaLogRouterModule',
    ])
    .controller('logManageMentHeiMaLogCtrl', ['$scope', 'trsHttpService', 'initComDataService', 'dateFilter', "modalDialog",
        function($scope, trsHttpService, initComDataService, dateFilter, modalDialog) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 0,
                };
                $scope.status = {
                    timeArray: [],
                    timeSelected: "",
                    copyCurrPage: 1,
                    searchcontent: "",
                };
                $scope.data = {
                    items: [],
                };
            }
            /**
             * [initData description] 数据初始化
             */
            function initData() {
                initDropDown();
                requestData();
            }
            /**
             * [requestData description] 请求数据
             */
            function requestData() {
                var params = {
                    'serviceid': 'mlflog',
                    'modelid': 'mlflogsearch',
                    'type': '8', //黑马校验日志
                    'startpage': $scope.page.CURRPAGE,
                    'pagesize': $scope.page.PAGESIZE,
                    'fileds': 'operator_info;media_name;display_name;operator_time;operator_ip;operate_desc',
                    'time': $scope.status.timeSelected.value,
                    'medianame': "",
                    'searchcontent': $scope.status.searchcontent,
                    'strsortmethod': '-operator_time',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getLogManageUrl(), params, 'get').then(function(data) {
                    $scope.data.items = data.CONTENT;
                    $scope.page.ITEMCOUNT = data.TOTALELEMENTS;
                    $scope.page.PAGECOUNT = data.TOTALPAGES;
                });
            }
            /**
             * [initDropDown description] 初始化下拉框
             */
            function initDropDown() {
                $scope.status.timeArray = initComDataService.logMgrTime();
                $scope.status.timeSelected = $scope.status.timeArray[1];
            }
            /**
             *  [selectPageNum 每页显示的数据数量]
             */
            $scope.selectPageNum = function() {
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };
            /**
             * [pageChanged 下一页 页面改变调取数据]
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };
            /**
             * [jumpToPage 跳转页]
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };
            /**
             * [searchWithKeyword description]条件过滤
             */
            $scope.searchWithKeyword = function(key, value) {
                var param;
                if (key == "time" && value.value == "custom") {
                    if (value.startdate === "" || value.enddate === "") {
                        modalDialog.alertType('检索失败', '检索时间不能为空', 'error', false);
                        return;
                    }
                    param = [dateFilter(value.startdate, 'yyyy-MM-dd'), dateFilter(value.enddate, 'yyyy-MM-dd')].join(';');
                } else {
                    param = value.value;
                }
                $scope.status.timeSelected.value = param;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE = 1;
                requestData();
            };
            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下空格也能提交]
             */
            $scope.fullTextSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.page.CURRPAGE = 1;
                    requestData();
                }
            };
            /**
             * [refresh description;刷新]
             */
            $scope.refresh = function() {
                $scope.page.CURRPAGE = $scope.status.copyCurrPage = '1';
                $scope.status.searchcontent = "";
                $scope.status.timeSelected = $scope.status.timeArray[1];
                requestData();
            };
            /**
             * [wordCount 提取字数]
             * @param  {[type]} value [description]
             * @return {[type]}       [description]
             */
            $scope.getNum = function(value) {
                var index1 = value.indexOf("wordCount:") + 10;
                var index2 = value.indexOf(",title:");
                var num = value.substring(index1, index2);
                if (value.indexOf("wordCountReal") > 0) {
                    num = num.split(":")[1];
                }
                return num;
            };
            /**
             * [groupPath 提取用户组织]
             * @param  {[type]} value [description]
             * @return {[type]}       [description]
             */
            $scope.getGroupPath = function(value) {
                var index1 = value.indexOf("groupPath:") + 10;
                var index2 = value.indexOf(",checkResult:");
                return value.substring(index1, index2 - 2);
            };
            /**
             * [getTitle 提取标题]
             * @param  {[type]} value [description]
             * @return {[type]}       [description]
             */
            $scope.getTitle = function(value) {
                var index1 = value.indexOf("title:") + 6;
                var index2 = value.indexOf(",groupPath:");
                return value.substring(index1, index2);
            };
        }
    ]);
